import { Logger } from '_clean-code/utils/logger';
import {
  CreateServiceActionParams,
  SERVICE_ACTION_KEY
} from './createServiceAction';

const ServiceMiddleware =
  ({ dispatch }) =>
  (next) =>
  async (action: CreateServiceActionParams) => {
    if (!action[SERVICE_ACTION_KEY]) {
      next(action);
      return;
    }

    try {
      dispatch({ type: action.doAction, payload: action.doActionPayload });

      const response = await action.do();

      dispatch({
        type: action.successAction,
        payload: response
      });
    } catch (error) {
      try {
        if (action.errorHandler) {
          action.errorHandler(error);
        }
        if (action.errorAction) {
          dispatch({ type: action.errorAction, payload: error });
        }
      } catch (e) {
        Logger.error('ServiceMiddleware::errorHandler:', e);
      }
      Logger.error(
        `ServiceMiddleware: ${action.doAction} failed with error`,
        error
      );
    }
  };

export default ServiceMiddleware;
